import React, { useState } from 'react';
import { C } from './constants/theme';
import { AuthProvider, useAuth } from './context/AuthContext';
import { Sidebar } from './components/Sidebar';
import { Topbar } from './components/Topbar';
import { LoginPage } from './modules/LoginPage';
import { DashboardHome } from './modules/DashboardHome';
import { ContentCategoryModule } from './modules/ContentCategoryModule';
import { ViewTypeModule } from './modules/ViewTypeModule';
import { ContainerMasterModule } from './modules/ContainerMasterModule';
import { MasterLayoutModule } from './modules/MasterLayoutModule';
import { ContentProvider } from './modules/ConentProviderModule';
import { UserModule } from './modules/UserModule';

const PAGES = {
  dashboard: DashboardHome,
  category: ContentCategoryModule,
  viewtype: ViewTypeModule,
  container: ContainerMasterModule,
  layout: MasterLayoutModule,
  feedProvider: ContentProvider,
  users: UserModule,
};

// ─── Full-screen loader shown during token validation ─────────────
function SplashLoader() {
  return (
    <div style={{
      minHeight: '100vh', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(135deg, #1A1340, #2D1B6E)',
      gap: 20,
    }}>
      <div style={{
        width: 64, height: 64, borderRadius: 18,
        background: C.primary, display: 'flex',
        alignItems: 'center', justifyContent: 'center', fontSize: 30,
      }}>📡</div>
      <div style={{
        width: 36, height: 36,
        border: '3px solid rgba(255,255,255,.2)',
        borderTopColor: '#fff', borderRadius: '50%',
        animation: 'spin .7s linear infinite',
      }} />
      <p style={{ color: 'rgba(255,255,255,.6)', fontSize: 14, margin: 0 }}>
        Verifying session…
      </p>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}

// ─── Protected dashboard shell ────────────────────────────────────
function Dashboard() {
  const { user, logout } = useAuth();
  const [page, setPage] = useState('dashboard');
  const [collapsed, setCollapsed] = useState(false);

  const sideW = collapsed ? 64 : 224;
  const PageComponent = PAGES[page] || DashboardHome;

  return (
    <div style={{ fontFamily: "'Inter', -apple-system, sans-serif", background: C.bg, minHeight: '100vh' }}>
      <Sidebar active={page} onNav={setPage} collapsed={collapsed} user={user} onLogout={logout} />
      <div style={{ marginLeft: sideW, transition: 'margin-left .25s', minHeight: '100vh' }}>
        <Topbar page={page} onToggleSidebar={() => setCollapsed((c) => !c)} user={user} onLogout={logout} />
        <div style={{ padding: 28, maxWidth: 1400 }}>
          <PageComponent onNav={setPage} />
        </div>
      </div>
    </div>
  );
}

// ─── Root router: loading → login → dashboard ─────────────────────
function AppRouter() {
  const { status } = useAuth();
  if (status === 'loading') return <SplashLoader />;
  if (status === 'unauthenticated') return <LoginPage />;
  return <Dashboard />;
}

export default function App() {
  return (
    <AuthProvider>
      <AppRouter />
    </AuthProvider>
  );
}
